module.exports = __webpack_public_path__ + "src/img/stylemarks/laptop-1.d0018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stylemarks/laptop-1.jpg
// module id = 116
// module chunks = 0